import { useMemo, useState } from "react";
import { filterTabs, topicList } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

const catTone: Record<string, string> = {
  蹲后续: "bg-secondary-100 text-secondary-800",
  连麦开撕: "bg-primary-100 text-primary-700",
  正面回应: "bg-accent-100 text-accent-700",
  爆料现场: "bg-background-100 text-foreground-700",
};

export default function TopicWall() {
  const [active, setActive] = useState("全部");
  const list = useMemo(() => (active === "全部" ? topicList : topicList.filter((t) => t.cat === active)), [active]);

  return (
    <section id="hot" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-8">
        <SectionHeading
          eyebrow="热门现场进行时"
          title="今日围观 · 事件正在跟进"
          desc="把正在发酵的瓜按类型排好，跟着大部队盯进度。想看哪一类，点一下就能切换。"
        />

        {/* filter */}
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <div className="flex flex-wrap items-center justify-center gap-1 rounded-full bg-background-50 p-1 ring-1 ring-background-200/80">
            {filterTabs.map((tab) => {
              const isActive = active === tab;
              return (
                <button
                  key={tab}
                  type="button"
                  onClick={() => setActive(tab)}
                  className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-600 hover:bg-background-100 hover:text-primary-600"
                  }`}
                >
                  {tab}
                </button>
              );
            })}
          </div>
        </div>

        {/* grid */}
        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((t) => (
            <article
              key={t.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[10/7] w-full overflow-hidden">
                <img
                  src={t.img}
                  alt={`${t.title}事件整理配图`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-semibold ${catTone[t.cat]}`}
                >
                  {t.cat}
                </span>
                <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-black/55 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
                  <i className="ri-eye-line"></i>
                  {t.watch}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-800">
                    <i className="ri-refresh-line"></i>
                    {t.status}
                  </span>
                </div>
                <h3 className="mt-3 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  {t.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-6 text-foreground-600">{t.brief}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line"></i>
                    {t.time}
                  </span>
                  <a
                    href="#scene"
                    className="inline-flex items-center gap-1 whitespace-nowrap font-semibold text-primary-600 hover:text-primary-700"
                  >
                    去跟进
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        {active === "全部" && (
          <p className="mt-10 text-center text-sm text-foreground-500">
            事件均来自公开讨论整理，随时可能反转，请理性围观。
            <a href="#faq" className="ml-1 font-medium text-primary-600 hover:text-primary-700">
              更多说明 →
            </a>
          </p>
        )}
      </div>
    </section>
  );
}